import Vendors from "../pages/vendors.vue"

export const VendorsRoutes = [{
  path: "/vendors",
  name: "مدیریت  وندورها",
  component: Vendors,
}
];
export default VendorsRoutes;
